import { render, staticRenderFns } from "./_base-submit-for-review.vue?vue&type=template&id=dc26e1a8"
import script from "./_base-submit-for-review.vue?vue&type=script&lang=js"
export * from "./_base-submit-for-review.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports